import { Component, OnInit, inject } from '@angular/core';
import { ChildActivationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { AppState } from '@shared/models/app-state.model';
import { AppVersionService } from '@shared/services/app-version.service';
import { CookieConsentService } from '@shared/services/cookie-consent.service';
import { FeatureFlagsService } from '@shared/services/feature-flag.service';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { MobileAppService } from '@shared/services/mobile-app.service';
import { getAuthPagesBranding } from '@shared/store/auth/auth.action';
import { resetSignUpBrandingColors } from '@shared/store/sign-up/branding/utils/reset-sign-up-branding-colors';
import { getBrandingDomain } from '@shared/utils/get-branding-domain';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, startWith, take } from 'rxjs/operators';

@Component({
  selector: 'cp-root',
  templateUrl: './app.component.html',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly store = inject(Store<AppState>);
  private readonly appVersionService = inject(AppVersionService);
  private readonly mobileAppService = inject(MobileAppService);
  private readonly cookieConsentService = inject(CookieConsentService);
  private readonly featureFlagsService = inject(FeatureFlagsService);
  private readonly maintenanceService = inject(MaintenanceService);
  protected readonly mobileAppRedirectFeatureEnabled = this.featureFlagsService.isFeatureEnabled(FeatureFlagEnum.MobileAppRedirect);

  readonly appLoading$: Observable<boolean> = combineLatest([
    this.router.events.pipe(
      filter((event) => event instanceof ChildActivationEnd),
      take(1),
      map(() => false),
      startWith(true),
    ),
  ]).pipe(map(([appLoading]) => appLoading));

  readonly mobileAppVersionCompatible$: Observable<boolean> = this.appVersionService.isAppVersionCompatible().pipe(take(1));

  constructor() {
    this.cookieConsentService.showDialog();
  }

  ngOnInit(): void {
    resetSignUpBrandingColors();

    this.maintenanceService
      .isMaintenanceModeEnabled()
      .pipe(take(1))
      .subscribe((maintenanceModeEnabled) => {
        if (maintenanceModeEnabled) return;

        this.store.dispatch(getAuthPagesBranding({ domain: getBrandingDomain() }));
      });

    // Handle mobile app
    this.mobileAppService.applyAppFeatures();
  }
}
